import * as z from "zod/v4";

export const deleteOrderTrackingOrderViewFolder = {
  name: "deleteOrderTrackingOrderViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
